import React from 'react';
import SalesTransactions from '../modules/SalesTransactions';

function SalesTransactionsPage(){
  return <SalesTransactions/>
}

export default SalesTransactionsPage;
